// RigSentinel · shared "Install on iPhone/iPad" instructions.
//
// Pure presentation, extracted so the exact same 3-step Add-to-Home-Screen
// copy renders identically wherever it's needed (Settings, /download) —
// no installation logic here, just the walkthrough UI.

import React from "react";
import { Share, SquarePlus } from "lucide-react";

const STEP_BADGE_STYLE = { background: "rgba(245,180,0,0.16)", color: "var(--rs-amber)" };

export function IosInstallSteps({ testId = "ios-install-steps" }) {
  return (
    <ol data-testid={testId} className="flex flex-col gap-2 text-[11.5px] text-[var(--rs-text-2)]">
      <li className="flex items-center gap-2">
        <span className="shrink-0 inline-flex items-center justify-center w-5 h-5 rounded-full font-mono-rs text-[10px] font-bold" style={STEP_BADGE_STYLE}>1</span>
        Tap the Safari <Share className="inline w-3 h-3 mx-0.5" /> Share button.
      </li>
      <li className="flex items-center gap-2">
        <span className="shrink-0 inline-flex items-center justify-center w-5 h-5 rounded-full font-mono-rs text-[10px] font-bold" style={STEP_BADGE_STYLE}>2</span>
        Choose <SquarePlus className="inline w-3 h-3 mx-0.5" /> &quot;Add to Home Screen&quot;.
      </li>
      <li className="flex items-center gap-2">
        <span className="shrink-0 inline-flex items-center justify-center w-5 h-5 rounded-full font-mono-rs text-[10px] font-bold" style={STEP_BADGE_STYLE}>3</span>
        Tap &quot;Add&quot;.
      </li>
    </ol>
  );
}

export default IosInstallSteps;
